'use strict';
define([], function() {
    function SinglePageLangCtrl($scope) {
    }
    SinglePageLangCtrl.$inject=['$scope'];
    return SinglePageLangCtrl;
});
